/** Shared `{ value, label }` enum entry shape served by the API, as it comes off the wire. */
export type AiUsagePayload = {
	readonly value: string;
	readonly label: string;
};

export type AiUsagesFetchedPayload = AiUsagePayload[];

export type AiUsagesFetchedAction = {
	type: 'AI_USAGES_FETCHED';
	payload: AiUsagesFetchedPayload;
};

export default (payload: AiUsagesFetchedPayload): AiUsagesFetchedAction => ({
	type: 'AI_USAGES_FETCHED',
	payload,
});
